export default class UtilsLogger {

  constructor() {

  }

  static log(type, message, params) {

    if (window['console'] !== undefined) {
      let date = new Date();

      if (params) {
        console.error(date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "." + date.getMilliseconds() + " [" + type + "] " + message + "\n", params);
      } else {
        console.log(date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "." + date.getMilliseconds() + " [" + type + "] " + message);
      }
    }
  }

  static info(type, message, params) {

    if (window['console'] !== undefined) {
      let date = new Date();
      console.log(date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "." + date.getMilliseconds() + " [" + type + "] " + message + "\n", params);
    }
  }

}
